const map = {
	"./en/discounts.json": 71838,
	"./en/mobile-paywall.json": 84735,
	"./es/discounts.json": 49621,
	"./es/mobile-paywall.json": 47318,
	"./fr/discounts.json": 85645,
	"./fr/mobile-paywall.json": 34350,
	"./ja/discounts.json": 14908,
	"./ja/mobile-paywall.json": 2825,
	"./pt/discounts.json": 39377,
	"./pt/mobile-paywall.json": 674,
	"./zh-Hant/discounts.json": 28529,
	"./zh-Hant/mobile-paywall.json": 67234
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50858;